import { branding, Colour_Tournament } from "./Utils";

export class FFTable {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "FFTable";
    this.scene = "FFTable";
    this.data = [];
    this.downloadPage = 7200;
    this.page = 50;
  }

  async preview({ options }) {
    this.onAir = false;

    let xml = await this.getVizPage({ page: this.downloadPage }).catch(
      (err) => {
        console.log(err);
      },
    );
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      let standings = options.standings?.data?.table?.comp?.group?.team;
      console.log("standings", standings);
      xml.payload.field.find((item) => {
        return item.attr.name === "00002";
      }).value = standings?.length;

      standings?.map((row, index) => {
        let team = options?.teams?.find((t) => t?.opta_ID === row?.id);
        let tab_row = (index + 1)?.toString()?.padStart(2, "0");

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "10";
        }).value = team?.variables?.badge || "";

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "11.active";
        }).value = "1";

        if (options.sod) {
          xml.payload.field.find((item) => {
            return item.attr.name === tab_row + "11";
          }).value = "0";
        } else {
          xml.payload.field.find((item) => {
            return item.attr.name === tab_row + "11";
          }).value =
            parseInt(row?.rank) < parseInt(row?.lastRank)
              ? "1"
              : parseInt(row?.rank) > parseInt(row?.lastRank)
                ? "-1"
                : "0";
        }

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "20";
        }).value = row?.rank;

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "21";
        }).value = team?.name;

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "22";
        }).value = row?.played;

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "24";
        }).value = row?.points;

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "0";
        }).value =
          options?.promotion?.findIndex(
            (t) => t?.team === team?.opta_ID && t?.type === "C",
          ) > -1
            ? "3"
            : options?.promotion?.findIndex(
                  (t) => t?.team === team?.opta_ID && t?.type === "R",
                ) > -1
              ? "4"
              : options?.selectedTeams?.findIndex((t) => t === team?.opta_ID) >
                  -1
                ? "2"
                : "1";

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "23";
        }).value =
          row?.pointsdiff > 0 ? "+" + row?.pointsdiff : row?.pointsdiff;

        xml.payload.field.find((item) => {
          return item.attr.name === tab_row + "30";
        }).value =
          // a divider under the bottom row separates nothing
          index < standings?.length - 1 &&
          (parseInt(row?.rank) ===
            parseInt(
              options?.game?.competition?.variables?.number_of_playoff_places,
            ) ||
            parseInt(row?.rank) ===
              options.standings_length -
                parseInt(
                  options?.game?.competition?.variables
                    ?.number_of_relegation_places,
                ))
            ? "1"
            : "0";
      });

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
